import Vue from 'vue'
import Vuex from 'vuex'
import Helper from '@/helpers/helper'

// helpers
import {
  getCollections,
  cleanrecord,
  addUpdateCollection,
  overridecollection,
  newJob
} from '@/helpers/localbase'

import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        /**
         * Window size
         */
        windowsize: {
            width      : window.innerWidth,
            innerHeight: window.innerHeight,
            breakpoint : Helper.windowbreakpoint()
        },
        /**
         * Employer order history
         */
        employerhistory: [],
        /**
         * Employees order history
         */
        employeeshistory: [],
        /**
         * Unread notifcation list
         */
        unreadnotifs: [],
        /**
         * Notif current data
         */
        notifdata: null,
        /**
         * flavors
         */
        flavors: [],
        /**
         * boxes
         * this are type of boxes that customer selecting when order type
         */
        boxes: [],
        /**
         * List of orders
         */
        orders: [],
        /**
         * Login status
         */
        islogin: false,
        /**
         * Previous route
         */
        routefrom: null,
        /**
         * Network status
         */
        isonline: true,
        /**
         * Delivery image proof
         */
        proofImage: null,
        /**
         * Logged In user
         */
        user: null,
        /**
         * Holes' settings
         */
        settings: [],
        /**
         * Employee's list
         */
        employees: [],
        /**
         * Socket io / webhook connection
         */
        socketio: null,
    },
    mutations: {
        updatenotifdata(state, payload) {
            state.notifdata = payload;
        },
        updateunreadnotifs(state, payload) {
            state.unreadnotifs = payload;
        },
        updatesocketio(state, payload) {
            state.socketio = payload;
        },
        updateemployees(state, payload) {
            state.employees = payload;
        },
        updatesettings(state, payload) {
            state.settings = payload;
        },
        updateflavors(state, payload) {
            state.flavors = payload;
        },
        updateboxes(state, payload) {
            state.boxes = payload;
        },
        updateuser(state, payload) {
            state.user = payload;
        },
        updateorderlist(state, payload) {
            state.orders = payload;
        },
        updateloginstatus(state, payload) {
            state.islogin = payload;
        },
        updateroutefrom(state, payload) {
            state.routefrom = payload;
        },
        updateProofImage(state, payload) {
            state.proofImage = payload;
        },
        updatenetworkstatus(state, payload) {
            state.isonline = payload;
        },
        updateemployerhistory(state, payload) {
            state.employerhistory = payload;
        },
        updateemployeeshistory(state, payload) {
            state.employeeshistory = payload;
        },
        udpatewindowsize(state, payload) {
            state.windowsize = payload;
        },
    },
    actions: {
        /**
         * Get latest notifications
         */
        async getunreadnotifs(context) {
            const url = `/get_unread_notifications`;
            const res = await axios.get(url).catch((err) => console.log(err));

            if (res.data) {
                context.commit("updateunreadnotifs", res.data.data);
                context.commit("updatenotifdata", res.data);
            } else if (!this.isonline) {
                /**
                 * If offline add request to job
                 */
                newJob({
                    url: url,
                    method: "GET",
                    callback: (data, options) => {
                        if (data.data) {
                            options.store.commit(
                                "updateunreadnotifs",
                                data.data
                            );
                            options.store.commit("updatenotifdata", data);
                        }
                    },
                });
            }
        },
        /**
         * Get flavors
         * pull from indexed db first
         */
        async getflavors(context) {
            const iflavors = await getCollections({ name: "flavors" });

            context.commit("updateflavors", iflavors);

            const url = "/flavors";
            const aflavors = await axios.get(url);

            if (aflavors.data.success) {
                const newdatas = aflavors.data.data;
                context.commit("updateflavors", newdatas);

                for (let index = 0; index < newdatas.length; index++) {
                    const flavor = newdatas[index];
                    addUpdateCollection({ name: "flavors", data: flavor });
                }

                /**
                 * Clean up records
                 * For tash data
                 */
                cleanrecord(newdatas, iflavors, "id", "flavors");
            } else if (!this.isonline) {
                /**
                 * If offline add request to job
                 */
                newJob({
                    url: url,
                    method: "GET",
                    callback: (data, options) => {
                        /**
                         * Check if success
                         * then update flavor state in store
                         * and add or update indexed db
                         */

                        if (data.success) {
                            const flavors = data.data;

                            options.store.commit("updateflavors", flavors);

                            for (
                                let index = 0;
                                index < flavors.length;
                                index++
                            ) {
                                const flavor = flavors[index];
                                options.db.addUpdateCollection({
                                    name: "flavors",
                                    data: flavor,
                                });
                            }
                        }
                    },
                });
            }
        },
        /**
         * Get Employees list by roles
         * @param {Object} context
         */
        async getemployees(context) {
            /**
             * Pull from indexed db first
             * and what role current loggedin user
             */
            const userrole = context.state.user.roles;
            const iemployees = await getCollections({ name: "employees" });

            /**
             * Filter employee list base on loggedin user role
             */
            let rolesneeded = [];
            if (userrole.includes("super-admin")) {
                const filteriemployees = iemployees.filter(
                    (em) =>
                        em.roles.includes("manager") ||
                        em.roles.includes("driver")
                );
                context.commit("updateemployees", filteriemployees);

                rolesneeded = ["manager", "driver"];
            } else if (userrole.includes("manager")) {
                const filteriemployees = iemployees.filter((em) =>
                    em.roles.includes("driver")
                );
                context.commit("updateemployees", filteriemployees);

                rolesneeded = ["driver"];
            }

            const url = "/list_users";
            const res = await axios
                .post(url, { roles: rolesneeded })
                .catch((err) => console.log(err));
            if (res.data.success) {
                const list = res.data.data;
                context.commit("updateemployees", list);
                /**
                 * Add / Update indexed db
                 */
                list.forEach((em) => {
                    addUpdateCollection({ name: "employees", data: em });
                });

                /**
                 * Clean up records
                 * For tash data
                 */
                cleanrecord(list, iemployees, "id", "employees");
            } else if (!context.state.isonline) {
                /**
                 * if offline add request to job
                 */
                newJob({
                    url: url,
                    method: "POST",
                    params: { roles: rolesneeded },
                    callback: (data, options) => {
                        /**
                         * Check if success
                         * then updates indexed db and store state
                         */
                        const list = data.data;

                        if (data.success) {
                            options.store.commit("updateemployees", list);
                        }

                        list.forEach((em) => {
                            options.db.addUpdateCollection({
                                name: "employees",
                                data: em,
                            });
                        });
                    },
                });
            }
        },
        /**
         * Get settings
         * pull from indexeddb first
         * @param {Object} context
         */
        async getsettings(context) {
            /**
             * Pull from indexeddb first
             */
            const isettings = await getCollections({ name: "settings" });
            context.commit("updatesettings", isettings);
            /**
             * Axios request
             */
            const url = "/holes_settings";
            const asettings = await axios
                .post(url)
                .catch((err) => console.log(err));

            if (asettings && asettings.data.success) {
                const newsettings = asettings.data.data;

                context.commit("updatesettings", newsettings);

                newsettings.forEach((setting) => {
                    addUpdateCollection({ name: "settings", data: setting });
                });

                /**
                 * Clean up records
                 * For tash data
                 */
                cleanrecord(newsettings, isettings, "id", "settings");
            } else if (!context.state.isonline) {
                // if offline add request to job
                newJob({
                    url: url,
                    method: "POST",
                    callback: (data, options) => {
                        /**
                         * Check if success
                         * then update store settings state
                         */

                        if (data.success) {
                            options.store.commit("updatesettings", data.data);

                            data.data.forEach((setting) => {
                                addUpdateCollection({
                                    name: "settings",
                                    data: setting,
                                });
                            });
                        }
                    },
                });
            }
        },
        /**
         * Get logged in user
         * pull from index db first
         */
        async getuser(context) {
            const iuser = await getCollections({ name: "user" });
            const [activeuser] = iuser;

            if (activeuser) {
                context.commit("updateuser", activeuser);
            }

            const url = "/profile";
            const auser = await axios.get(url);

            if (auser.data.success) {
                context.commit("updateuser", auser.data.data);
                overridecollection({ name: "user", data: [auser.data.data] });
            } else if (context.state.isonline) {
                newJob({
                    url: url,
                    method: "GET",
                    callback: (data, options) => {
                        if (data.success) {
                            options.store.commit("updateuser", data.data);
                            options.overridecollection({
                                name: "user",
                                data: [data.data],
                            });
                        }
                    },
                });
            }
        },
        /**
         * Fetch all orders
         * pull in indexed db first
         */
        async getorders(context) {
            const iorders = await getCollections({ name: "orders" });
            context.commit("updateorderlist", iorders);

            const url = "/all_orders";
            const apiorders = await axios
                .get(url)
                .catch((err) => console.log(err));

            if (apiorders) {
                let newdatas = [...apiorders.data.data];
                let nextpage = apiorders.next_page_url;

                while (nextpage) {
                    const res = await axios
                        .get(url)
                        .catch((err) => console.log(err));

                    if (res) {
                        newdatas = [...newdatas, ...res.data.data];
                        nextpage = res.data.next_page_url;
                    } else {
                        nextpage = null;
                    }
                }

                // console.table(newdatas)

                context.commit("updateorderlist", newdatas);

                /**
                 * Add to index db
                 */
                for (let index = 0; index < newdatas.length; index++) {
                    const order = newdatas[index];
                    addUpdateCollection({ name: "orders", data: order });
                }

                /**
                 * Clean up records
                 * For tash data
                 */
                cleanrecord(newdatas, iorders, "id", "orders");
            } else if (!context.state.isonline) {
                /**
                 * If offline add request to job
                 */
                newJob({
                    url: url,
                    method: "GET",
                    callback: (data, options) => {
                        options.store.commit("updateorderlist", data);

                        /**
                         * Add and update indexed db
                         */
                        for (let index = 0; index < data.length; index++) {
                            const order = data[index];
                            options.db.addUpdateCollection({
                                name: "orders",
                                data: order,
                            });
                        }
                    },
                });
            }
        },
    },
});
